module.exports = __webpack_public_path__ + "img/logo-ptt.c860cb33.png";